// External Dependencies
import React, { Component } from 'react';
import firebase from 'firebase';
import RaisedButton from 'material-ui/RaisedButton';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import {
  deepPurple400,
  green500,
  grey50,
} from 'material-ui/styles/colors';

// Local Dependencies
import AttendanceList from './attendance-list';
import Title from '../../shared/title';
import { firebaseRef } from '../../config/constants';

// Local Variables
const rootStyles = {
  padding: 16,
  width: '100%',
};

const coderListStyles = {
  paddingLeft: 32,
};

const buttonContainerStyles = {
  alignContent: 'flex-start',
  display: 'flex',
  marginLeft: 18,
};

const buttonstyles = {
  backgroundColor: deepPurple400,
};

const buttonLabelStyles = {
  color: grey50,
};

const submittedContainerStyles = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'left',
  margin: 32,
};

const submittedMessageStyles = {
  fontWeight: 500,
  marginLeft: 16,
};

const iconStyles = {
  height: 50,
  width: 50,
};

const numberSelectedStyles = {
  color: deepPurple400,
  fontSize: 20,
};

// Component Definition
class UpdateAttendance extends Component {
  state = {
    checked: false,
    names: [],
    numberSelected: 0,
    showAttendanceDoneMessage: false,
  }

  componentDidMount() {
    firebaseRef.child('coders').on('value', (snapshot) => {
      const names = snapshot.val();
      const fullNames = [];

      let id = 0;

      // TODO: map over the names array instead of using for...in
      for (const i in names) {
        fullNames.push({
          checked: false,
          // We need to user the ++ operator here or firebase won't recognize it
          id: id++,
          name: `${names[i].firstName} ${names[i].lastName}`,
        });
      }

      const sortedNames = fullNames.sort((a, b) => a.name.localeCompare(b.name));

      this.setState({ names: sortedNames });
    });
  }

  handleToggle = (id) => {
    const {
      numberSelected,
    } = this.state;

    const updatedCoders = this.state.names.map((coder) => {
      if (coder.id === id) {
        coder.checked = !coder.checked;
        if (coder.checked) this.setState({ numberSelected: numberSelected + 1 });
        else if (!coder.checked) this.setState({ numberSelected: numberSelected - 1 });
      }
      return coder;
    });
    this.setState({ names: updatedCoders });
  };

  handleClickSubmitAttendance = () => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        const idArray = [];
        this.state.names.forEach((coder) => {
          if (coder.checked) {
            idArray.push(coder.id);
          }
        });
        const date = new Date().toString();
        if (idArray.length) {
          idArray.forEach((coderId) => {
            firebaseRef.child('coders').child(coderId).child('attendance').push(date);
          });
          this.setState({
            numberSelected: 0,
            showAttendanceDoneMessage: true,
          });
        }
      }
    });
    window.scroll(0, 0);
  }

  render() {
    const {
      names,
      numberSelected,
      showAttendanceDoneMessage,
    } = this.state;

    const renderAttendanceSubmittedSection = showAttendanceDoneMessage &&
    (
      <div style={submittedContainerStyles}>
        <CheckIcon color={green500} style={iconStyles} />
        <div style={submittedMessageStyles}>Attendance Submitted. YOU DID IT!</div>
      </div>
    );

    const renderNumberSelectedSection = (
      <div style={numberSelectedStyles}>
        {numberSelected} selected
      </div>
    );

    return (
      <div style={rootStyles}>
        <Title>Update Attendance</Title>
        <div
          className="student-container"
          style={coderListStyles}
        >
          {renderAttendanceSubmittedSection}
          {renderNumberSelectedSection}
          <AttendanceList
            coders={names}
            onToggle={this.handleToggle}
          />
          <div style={buttonContainerStyles}>
            <RaisedButton
              label="Submit Attendance"
              onClick={this.handleClickSubmitAttendance}
              buttonStyle={buttonstyles}
              labelStyle={buttonLabelStyles}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default UpdateAttendance;



/** WEBPACK FOOTER **
 ** ./src/dashboard/update-attendance/index.js
 **/